import Authorization from "policies/Authorization";
import React from "react";
import ExportScheduleView from "./ExportScheduleView";

export default function ExportScheduleContainer({ isInDropDown, closeMenu, setExportScheduleModalOpen }) {
  const policy = Authorization.usePolicy();

  return (
    <ExportScheduleView
      canExport={policy.canExport(Authorization.EntityTypes.WorkBlock)}
      closeMenu={closeMenu}
      isInDropDown={isInDropDown}
      setExportScheduleModalOpen={setExportScheduleModalOpen}
    />
  );
}
